import React, { useState } from 'react'
import { Tab } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import { Typography } from '@mui/material'

import NewDashboardFilters from '@/components/UI/Dashboard/DashboardFilters/NewDashboardFilters'
import CustomTabs from '@/components/UI/CustomTabs'
import ExportReportShared from '@/components/UI/ExportReportShared/ExportReportShared'
import ConvoLogs from './ConvoLogs'
import DashboardNavigation from '../Dashboard/pages/DashboardNavigation'

const BotResponses = () => {
  const { t } = useTranslation('translation')
  const history = useHistory()
  const [filters, setfilters] = useState({
    filter_from_date: null,
    filter_to_date: null,
    filter_channel: null,
    filter_connection_ids: null,
    filter_botmode: null,
  })
  const queryParams = new URLSearchParams(history.location.search)
  const [activeTab, setActiveTab] = useState<string>(
    queryParams.get('activeTab') || 'all',
  )

  const validTabs = ['all', 'document_searching', 'improvising', 'unanswered']

  const hasFilterUpdated = async (e: any) => {
    setfilters({
      ...filters,
      ...e,
    })
  }

  const handleTabChange = (key: string) => {
    setActiveTab(key)
    if (key === 'all') {
      setfilters({
        ...filters,
        filter_botmode: null,
      })
    } else {
      setfilters({
        ...filters,
        filter_botmode: key,
      })
    }
  }

  return (
    <section className="dashborad-wraper">
      <NewDashboardFilters hasFilterUpdated={hasFilterUpdated} />

      <DashboardNavigation />

      <div className="all-knowledge-search responses-by-ai tw-pt-4 tw-flex tw-flex-col tw-gap-4">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <Typography variant="body2" color="text.secondary">
              {t("Review learners’ questions and AI Assistant's answers.")}
            </Typography>
          </div>
        </div>

        <div className="chat-responses-tab mt-0">
          <CustomTabs
            defaultActiveKey="all"
            activeKey={activeTab}
            validTabs={validTabs}
            queryParamName="activeTab"
            onTabChange={handleTabChange}
            headerActions={
              <ExportReportShared
                name={'conversation-logs'}
                exportName={filters?.filter_botmode || 'all_questions'}
                filtersData={filters}
                removedKeyFromObject="filter_connection_ids, page, page_size"
                exportFont={true}
              />
            }
          >
            <Tab eventKey="all" title={t('All Responses')}>
              {activeTab === 'all' && <ConvoLogs filters={filters} />}
            </Tab>
            <Tab
              eventKey={'document_searching'}
              title={t('Contextualised Chat Responses')}
            >
              {activeTab === 'document_searching' && (
                <ConvoLogs filters={filters} />
              )}
            </Tab>
            <Tab
              eventKey="improvising"
              title={t('Responses from External Sources')}
            >
              {activeTab === 'improvising' && <ConvoLogs filters={filters} />}
            </Tab>
            <Tab eventKey="unanswered" title={t('Unanswered Questions')}>
              {activeTab === 'unanswered' && <ConvoLogs filters={filters} />}
            </Tab>
          </CustomTabs>
        </div>
      </div>
    </section>
  )
}

export default BotResponses
